export default __webpack_public_path__ + "static/media/blackBG.0fa63681.jpg";